import { useAuth0 } from "@auth0/auth0-react";
import { Filter } from "@material-ui/icons";
import FilterListIcon from "@material-ui/icons/FilterList";
import { DatePickerField } from "_metronic/_partials/controls";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import CrossSvg from "assets/icons/svg/cross";
import { InputField, LabelField, RadioButton, SelectField } from "components";
import Button from "components/button/Button";
import MyButton from "components/MyButton";
import SearchComp from "components/Searchcomponent";
import { useFormik } from "formik";
import { useSearch } from "hook";
import AuthService from "Lib/API/Auth/index";
import FinanceSettingService from "Lib/API/FinanceSetting/FinanceSetting";
import MembersSettingService from "Lib/API/MemberSetting/MemeberSetting";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select";
import FinanceService from "../../Lib/API/Finance";
import InfoTooltip from "../../components/InfoTooltip";
// import InputRange from "react-input-range";

const selectControlStyles = {
  backgroundColor: "rgb(243, 246, 249)",
  borderColor: "#FFFFFF",
  color: "#b5b5c3",
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",
};
const colourStyles = {
  control: (styles) => ({
    ...styles,
    ...selectControlStyles,
  }),
};

const accountTypeOptions = [
  {
      label: "Member",
      _id: "member",
  },
  {
      label: "Organization",
      _id: "organization",
  },
  {
      label: "Not a Member",
      _id: "non-member",
  },
]


export const BatchBillingFilters = ({
  filter,
  onSearchChange,
  onAccountTypeChange,
  onCategoryTypeChange,
  onBillingTypeChange,
  formik,
  onPreviousStatusChange,
  amountRange,
  dateRange,
  onClear,
  debounceSearch,
  onClearList,
  setOnClearList,
  // onPreviousStatusChange,
  onAccountTagsChange,
  onContactTagsChange,
}) => {
  const [loading, setLoading] = useState(false);
  const [openFilter, setOpenFilter] = useState(true);
  const [ledgers, setLedgers] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [onSearch, setOnSearch] = useState("");
  const [defaultBillingType, setDefaultBillingType] = useState([]);
  const { searchAction } = useSearch({ action: setOnSearch });
  const [accountBillingTypes, setAccountBillingTypes] = useState();
  const [catagoryTypes, setCatagoryTypes] = useState([]);
  const [inputRange, setInputRange] = useState({ min: 0, max: 2 });
  const [card, setCard] = useState(null);
  const [selectfieldColor, setSelectfieldColor] = useState(true);
  const [accountTags, setAccountTags] = useState([]);
  const [accountTagsLoading, setAccountTagsLoading] = useState(false);
  const [contactTags, setContactTags] = useState([]);
  const [contactTagsLoading, setContactTagsLoading] = useState(false);
  

  const handleFilter = () => {
    setOnClearList(false);

    if (
      openFilter === true &&
      (filter?.search ||
        filter?.filter?.billing_type ||
        filter?.filter?.category ||
        filter?.filter?.account_type)
    ) {
      debounceSearch();
    }

    // setOpenFilter(!openFilter);
  };
  useEffect(() => {
    if (formik.values?.category_type) {
      onCategoryTypeChange(formik.values?.category_type);
    }
    if (formik.values?.account_type) {
      onAccountTypeChange(formik.values?.account_type);
    }
    if (formik.values?.billing_type) {
      onBillingTypeChange(formik.values?.billing_type);
    }
    if (formik.values?.accountTags) {
      onAccountTagsChange(formik.values?.accountTags);
    }
    if (formik.values?.contactTags) {
      onContactTagsChange(formik.values?.contactTags);
    }
  }, [formik.values]);

  const radioList = [
    { name: "Charged date", value: "charge_date" },
    { name: "Due Date", value: "due_date" },
  ];

  const formatOptionLabel = ({ label, _id }, e) => {
    if (label && _id) {
      return (
        <div className="dropdown-container" key={_id ? _id : ""}>
          <div className="icon-name-container d-flex align-items-center justify-content-start">
            <div className="name-container" style={{ marginInlineStart: 10 }}>
              <div>{label ? label : ""}</div>
            </div>
          </div>
        </div>
      );
    }
  };
  useEffect(() => {
    handleFilter();
  }, [onClearList]);
  
  const onFilterClear = () => {
    formik.setFieldValue("account_type", "");
    // formik.setFieldValue("ledger", {});
    formik.setFieldValue("category_type", { id: "", name: "" });
    formik.setFieldValue("search", "");
    {
      formik?.values?.batch_type === "account"
      ? formik.setFieldValue("billing_type", defaultBillingType)
      : formik.setFieldValue("billing_type", []);
    }
    formik.setFieldValue("accountTags", undefined);
    formik.setFieldValue("contactTags", undefined);
    onClear();
  };
  useEffect(() => {
    setDefaultBillingType(formik?.values?.billing_type);
  }, []);
  const billingOptions =
    accountBillingTypes &&
    accountBillingTypes?.map((item) => {
      return {
        label: item?.title,
        _id: item?._id,
      };
    });
  const categoryOptions =
    catagoryTypes &&
    catagoryTypes?.map((item) => {
      return {
        label: item?.title,
        _id: item?._id,
      };
    });

  const options =
    ledgers &&
    ledgers?.map((item) => {
      return {
        label: item.led_acc_name,
        value: item._id,
      };
    });
  // Get Account Billing Types List
  const fetchAccountBillingTypes = async () => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.getAccountBillingTypes(token).then((res) => {
      setAccountBillingTypes(res?.result);

      // setAccountBillingTypes(res?.result?.map((item) => item.title));
    }).catch((error) => {
      console.log(error);
      toastr.error(error?.data?.message);
    });
  };
  const getTypes = async () => {
    const token = await getAccessTokenSilently();
    const type = formik.values?.account_type;
    await MembersSettingService.getCatagoryListByType(
      type === "non-member" ? "not_member" : type ? type : "not_member",
      token
    ).then((res) => {
      setCatagoryTypes(res?.result);
    }).catch((error) => {
      console.log(error);
      toastr.error(error?.data?.message);
    });
  };

  const getAccountTagsHandler = async () => {
    const token = await getAccessTokenSilently();
    setAccountTagsLoading(true);
    AuthService.getTags(
      'account',
      "",
      "",
      token
    )
      .then((res) => {
        const tags = res?.result;
        const filterTags = tags?.map((item) => {
          return {
            label: item?.title,
            value: item?._id,
          };
        });
        setAccountTags(filterTags);
      })
      .catch((err) => {
        console.log('err: ', err);
        toastr.error('Error', err?.data?.message || 'Something went wrong');
      }).finally(() => {
        setAccountTagsLoading(false);
      });
  };
  const getContactTagsHandler = async () => {
    const token = await getAccessTokenSilently();
    setContactTagsLoading(true);
    AuthService.getTags(
      'contact',
      "",
      "",
      token
    )
      .then((res) => {
        const tags = res?.result;
        const filterTags = tags?.map((item) => {
          return {
            label: item?.title,
            value: item?._id,
          };
        });
        setContactTags(filterTags);
      })
      .catch((err) => {
        console.log('err: ', err);
        toastr.error('Error', err?.data?.message || 'Something went wrong');
      }).finally(() => {
        setContactTagsLoading(false);
      });
  };



  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };
  React.useEffect(() => {
    getTypes();
    fetchAccountBillingTypes();
  }, [formik.values?.account_type]);

  
  React.useEffect(() => {
    getAccountTagsHandler();
    getContactTagsHandler();
  }, []);
  
  


  const filter_by = ["All", "charge", "payment"];
  return (
    <div className="filteration batch-biilling-filteration">
      <div className="activated-ledger d-flex flex-column pl-6 flex-lg-row justify-content-between mb-5">
        <div className="sub-header-functions col-12">
          <div className="col-sm-4 batch-filter">
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <LabelField title="Account Name" />
              <InfoTooltip text="Search accounts by name to narrow down which accounts are shown below." style={{ marginLeft: '6px', marginBottom: '8px' }} />
            </div>
            <SearchComp
              title={"Account Name"}
              value={filter?.search != undefined ? filter?.search : ""}
              setSearchText={onSearchChange}
              placeholder="Search "
              batchbilling="batchbilling"
            />
          </div>
          {!openFilter ? (
            <div className="col-sm-4 account-filter-button">
              <MyButton
                type="secondary"
                content={
                  <div className="">
                    <FilterListIcon style={{ marginRight: "5px" }} />
                    Filter
                  </div>
                }
                style={openFilter ? { opacity: 0.3 } : {}}
                onClick={() => setOpenFilter(!openFilter)}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      {openFilter && (
        <div className="filter batch-filter-section mb-4">
          <div className=" text-right pr-5 pt-5">
            <span></span>
          </div>
          <div className="row  pl-10 finance-tilter">
            <div className="col-sm-12 d-flex pr-13">
              <div className="col-sm-4">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <LabelField title={"Account type"} />
                  <InfoTooltip text="Filter to only Members, Organizations, or Non-Members." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                </div>
                  <Select
                  mandatory={true}
                  {...{
                    formik,
                    name: `account_type`,
                    checkValidation: false,
                    placeholder: "Select",
                  }}
                  batchBillingFilterInputs="batchbillingfilterinput"
                  isClearable={formik.values.account_type ?? false}
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={accountTypeOptions}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={(value) => {
                    if(!value) {
                      formik.setFieldValue(`account_type`, "");
                      return;
                    }
                    formik.setFieldValue(`account_type`, value?._id);
                    formik.setFieldValue("category_type", { id: "", name: "" });
                  }}
                  value={accountTypeOptions.find((item) => item._id === formik.values?.account_type) || ""}
                  components={{ DropdownIndicator }}
                />
              </div>
              <div className="col-sm-4">
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <LabelField title={"By Category"} />
                  <InfoTooltip text="Filter accounts to a specific category, based on the selected Account type." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                </div>
                <Select
                  mandatory={true}
                  {...{
                    formik,
                    name: `category_type`,
                    checkValidation: false,
                    placeholder: "Select",
                  }}
                  isClearable={formik.values?.category_type?.id ?? false}
                  batchBillingFilterInputs="batchbillingfilterinput"
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={categoryOptions}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={(value) => {
                    if(!value) {
                      formik.setFieldValue(`category_type`, {
                        name: "",
                        id: "",
                      });
                      return;
                    }
                    formik.setFieldValue(`category_type`, {
                      name: value?.label,
                      id: value?._id,
                    });
                  }}
                  value={{
                    label: formik.values?.category_type?.name,
                    _id: formik.values?.category_type?.id,
                  }}
                  components={{ DropdownIndicator }}
                />
              </div>

              <div
                className={
                  formik.values?.batch_type === "account"
                    ? "col-sm-4 account-subtype-field "
                    : "col-sm-4 account-subtype-field"
                }
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <LabelField title={"By Billing Type"} />
                  <InfoTooltip text="Only accounts with one of the selected billing types will be included in this batch." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                </div>

                <Select
                  mandatory={true}
                  {...{
                    formik,
                    name: `billing_type`,
                    checkValidation: false,
                    placeholder: "Select",
                  }}
                  isMulti={ formik?.values?.batch_type === "account" }
                  isClearable={formik.values?.billing_type?.id ?? false}
                  batchBillingFilterInputs="batchbillingfilterinput"
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={billingOptions}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={(value) => {
                    if(!value) {
                      formik.setFieldValue(`billing_type`, []);
                      return;
                    }
                    formik.setFieldValue(`billing_type`, [{
                      name: value?.label,
                      id: value?._id,
                    }]);
                  }}
                  value={
                      formik.values?.billing_type?.map(item => ({
                      label: item?.name,
                      _id: item?.id,
                    })) 
                  } 
                  components={{ DropdownIndicator }}
                  isDisabled={
                    formik?.values?.batch_type === "account" ? true : false
                  }
                />
              </div>
           

            </div>
              {formik.values?.batch_type === "manual" && (
                <div className="col-sm-12 d-flex pr-13 mt-5">
                  <div
                    className={ "col-sm-4 account-subtype-field"}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <LabelField title={"Account Tags"} />
                      <InfoTooltip text="Filter accounts to only those with the selected account tags." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                    </div>
                    <Select
                        {...{
                            formik,
                            name: `accountTags`,
                            mandatory: false,
                            checkValidation: false,
                        }}
                        classNamePrefix="react-select"
                        options={accountTags}
                        valueKey="id"
                        labelKey="name"
                        isMulti
                        isLoading={accountTagsLoading}
                        styles={colourStyles}
                        onChange={(value) => {
                            formik.setFieldValue(`accountTags`, value?.map(item => (item?.label)));
                        }}
                        value={accountTags.filter(item => formik.values?.accountTags?.includes(item?.label))}
                        components={{ DropdownIndicator }}
                    />
                  </div>
                  <div
                    className={ "col-sm-4 account-subtype-field"}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <LabelField title={"Contact Tags"} />
                      <InfoTooltip text="Filter accounts to only those whose associated contacts have the selected tags." style={{ marginLeft: '6px', marginBottom: '8px' }} />
                    </div>
                    <Select
                        {...{
                            formik,
                            name: `contactTags`,
                            mandatory: false,
                            checkValidation: false,
                        }}
                        classNamePrefix="react-select"
                        options={contactTags}
                        valueKey="id"
                        labelKey="name"
                        isMulti
                        isLoading={contactTagsLoading}
                        styles={colourStyles}
                        onChange={(value) => {
                            formik.setFieldValue(`contactTags`, value?.map(item => (item?.label)));
                        }}
                        value={contactTags.filter(item => formik.values?.contactTags?.includes(item?.label))}
                        components={{ DropdownIndicator }}
                    />
                  </div>
                </div>
              )}
          </div>

          <div className="pr-4 pl-9 justify-content-end d-flex pb-5 pr-13 mt-5">
            <Button
              variant="primary-outline"
              size="md"
              type="secondary"
              onClick={onFilterClear}
              style={{ marginRight: 10, minWidth: 80 }}
            >
              <span className="">Clear</span>
            </Button>
            <Button
              variant="primary"
              size="md"
              className="btn btn-primary"
              style={{ minWidth: 70 }}
              onClick={handleFilter}
            >
              Filter
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};
